// extracted by mini-css-extract-plugin
module.exports = {"product-card":"styles-module__product-card___3RT8J","product-image":"styles-module__product-image___2uy_e"};